export const blockIconsTravelVillaNew = (
	<span className='material-symbols-outlined'>villa</span>
);
